import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import { useMemo } from 'react'
import { ChartDayData, GenericChartEntry, PoolChartEntry, TokenChartEntry } from 'types/analytics'
import { formatUTCDay, unixToType } from 'utils/analytics/date'

dayjs.extend(utc)
dayjs.extend(weekOfYear)

type ChartData = ChartDayData[] | PoolChartEntry[] | TokenChartEntry[] | undefined

export function useTransformedChartData(chartData: ChartData, type: 'month' | 'week', metric: 'volumeUSD' | 'feesUSD') {
  return useMemo(() => {
    if (!chartData) return []

    const data: Record<string, GenericChartEntry> = {}

    chartData.forEach((entry: any) => {
      const group = unixToType(entry.date, type)
      const value = entry[metric] ?? 0
      const currentDate = formatUTCDay(entry.date) // string

      if (data[group]) {
        data[group].value += value
        // overwrite with the latest time string if newer
        if (dayjs(currentDate).isAfter(dayjs(data[group].time))) {
          data[group].time = currentDate
        }
      } else {
        data[group] = {
          time: currentDate,
          value,
        }
      }
    })

    return Object.values(data).sort((a, b) => dayjs(a.time).valueOf() - dayjs(b.time).valueOf())
  }, [chartData, type, metric])
}
